export const SETUP_USER_WEB_SOCKET = 'SETUP_USER_WEB_SOCKET';
export const SAVE_CREDENTIALS = 'SAVE_CREDENTIALS';

export const setupUserSocket = channelId => {
  return {
    type: SETUP_USER_WEB_SOCKET,
    channelId,
  };
};

export const saveCredentials = credentials => {
  return {
    type: SAVE_CREDENTIALS,
    credentials,
  };
};
